<div  [hidden]="!error" 
      [className]="className" 
      [style]="styleName">
               <b [className]="labelClass" [style]="labelStyle">{{!error? '':'error.prefix' | translate}}</b>
               <span [className]="textClass" [style]="textStyle" [hidden]="_isBool"
                     [innerHTML]="error|translate:errorParam" ></span>
               <span translate><ng-content></ng-content></span>      
</div>

<div  [hidden]="!errorList || errorList.length == 0" 
      [style]="styleName">

          <div *ngFor="let err of errorList" [hidden]="!err" [className]="className">
               <b [className]="labelClass" [style]="labelStyle" translate>{{!error? '':'error.prefix' | translate}}</b>
               <span [className]="textClass" [style]="textStyle"  
                     [innerHTML]="err|translate:errorParam" ></span>
          </div>
          
</div>
